import React from "react";
import { Formik, Form, Field } from "formik";
import VisualCheckForm from "./VisualCheckForm";
import StageFooter from "./StageFooter";
import FileUploaderUI from "./ViewRFI/FileUploaderUI";
import useAssemblyStage from "../hooks/useAssemblyStage";
import { Box, CircularProgress } from "@mui/material";
import StageInactive from "./ViewRFI/StageInactive";

export default function AssemblyDocsAndVisualCheck({
  formEnabled,
  showAction,
  showSubmitButton,
  awaitingReview,
  isAPICallAllowed,
  stage,
  isActive,
}) {
  const {
    loading,
    initialValues,
    validationSchema,
    handleDocumentDelete,
    handleFilesSelect,
    handleSubmit,
    handleDeletePart,
  } = useAssemblyStage(stage.stage_id, isAPICallAllowed);

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : isActive ? (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            setFieldValue,
            submitForm,
            isSubmitting,
          }) => (
            <Form id="assembly-docs-and-visual-check-form">
              {/* Document Upload Section */}
              <Field name="documents">
                {({ field }) => (
                  <>
                    <FileUploaderUI
                      files={field.value}
                      onFilesSelect={(files) =>
                        handleFilesSelect(files, setFieldValue, field.value)
                      }
                      onFileDelete={(file) =>
                        handleDocumentDelete(file, setFieldValue, field.value)
                      }
                      acceptedFileTypes={[".pdf", ".doc", ".docx"]}
                      error={errors.documents}
                      touched={touched.documents}
                      inputProps={{ id: "document-upload-input-assembly" }}
                      title="Upload Documents"
                      viewOnly={!formEnabled}
                    />
                  </>
                )}
              </Field>

              {/* Visual Check Section */}
              <VisualCheckForm
                values={values}
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                viewOnly={!formEnabled}
                handleDeletePart={handleDeletePart}
              />

              <StageFooter
                showAction={showAction}
                showSubmitButton={showSubmitButton}
                onSendForApproval={submitForm}
                isSubmitting={isSubmitting}
                awaitingReview={awaitingReview}
                stage={stage}
              />
            </Form>
          )}
        </Formik>
      ) : (
        <StageInactive />
      )}
    </>
  );
}
